import { Link } from "react-router-dom";
import { Button } from "./ui/button";
import { trackCTAClick } from "../utils/analytics";

/**
 * Shared lead-generation CTA block for public marketing pages.
 * Primary: Start Free Trial · Secondary: View Pricing · Optional: Book a Demo
 */
export const MarketingCta = ({ page, heading = "Ready to Get Clarity on Your Agreement?", subtext = "Guided 14-day pilot — upload one agreement, get 20 answered questions, onboarding call included. No credit card." }) => (
  <section className="py-16 border-t border-border/40 bg-muted/20 px-4" data-testid={`${page}-cta-section`}>
    <div className="max-w-2xl mx-auto text-center">
      <h2 className="font-heading text-2xl sm:text-3xl font-semibold text-foreground mb-4">{heading}</h2>
      <p className="text-sm text-muted-foreground mb-8 max-w-md mx-auto">{subtext}</p>
      <div className="flex flex-col sm:flex-row gap-3 justify-center">
        <Link to="/register">
          <Button size="lg" className="w-full sm:w-auto" data-testid={`${page}-start-free-btn`} onClick={() => trackCTAClick(`${page}_start_guided_pilot`)}>
            Start a guided pilot
          </Button>
        </Link>
        <Link to="/pricing">
          <Button size="lg" variant="outline" className="w-full sm:w-auto" data-testid={`${page}-view-pricing-btn`} onClick={() => trackCTAClick(`${page}_view_pricing`)}>
            View Pricing
          </Button>
        </Link>
        <Link to="/contact-sales">
          <Button size="lg" variant="ghost" className="w-full sm:w-auto" data-testid={`${page}-book-demo-btn`} onClick={() => trackCTAClick(`${page}_book_demo`)}>
            Book a Demo
          </Button>
        </Link>
      </div>
    </div>
  </section>
);

export default MarketingCta;
